/**
 * Default document language for the Vue SPA (`<html lang>`).
 * Override at build time for LATAM, e.g. `VITE_APP_DOCUMENT_LANG=pt-BR`.
 */
export const APP_DOCUMENT_LANG: string = import.meta.env.VITE_APP_DOCUMENT_LANG || "ru";

export function applyDocumentLang(lang: string = APP_DOCUMENT_LANG): void {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lang;
}
